// extracted by mini-css-extract-plugin
export default {"TeamMember":"TeamMembers_TeamMember__rCJXM"};